import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from '../../../../hooks';

const mashupRecentHistory = [
  { amount: 2, date: new Date(), points: 80 },
  { amount: 1, date: new Date(), points: 40 },
  { amount: 2, date: new Date(), points: 80 },
];

const usePulseNChillPoints = () => {
  const { themeContext, theme } = useTheme();
  const {
    userPoints,
  } = useLoyalty();

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return {
    background,
    history,
    userPoints: 2200,
    mashupRecentHistory,
  }
}

export default usePulseNChillPoints